// extracted by mini-css-extract-plugin
module.exports = {"Arrow":"Pagination_Arrow__35DZ6","Active":"Pagination_Active__1lApn"};